import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const override = {
  PERFORM_APP_DYNAMICS: API_ENDPOINTS.PERFORM_APP_DYNAMICS.TEST,
  hostname: API_ENDPOINTS.HOSTNAME.TEST,
  RTI_ENDPOINT: API_ENDPOINTS.RTI_ENDPOINT.TEST,
  RTI_X_API_VALUE: API_ENDPOINTS.RTI_X_API_VALUE.TEST,
  RTI_X_API_KEY: API_ENDPOINTS.RTI_X_API_KEY.COMMON,
  PP_ENDPOINT: API_ENDPOINTS.PP_ENDPOINT.TEST,
  APP_DYNAMIC_KEY: API_ENDPOINTS.APP_DYNAMIC_KEY.TEST,
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.TEST,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.TEST,
  DIS_X_API_KEY: API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  CREDIT_APP_ENPOINT:API_ENDPOINTS.CREDIT_APP_ENPOINT.TEST,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.TEST,
};

export const environment = defaultsDeep(override, environmentDefaults);
